// extracted by mini-css-extract-plugin
export var container = "_5x-0";
export var infoButton = "_5x-1";
export var label = "_5x-3";
export var labelExpanded = "_5x-4";
export var price = "_5x-5";
export var priceExpanded = "_5x-6";
export var title = "_5x-2";